import React, { useEffect, useState } from 'react'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner'
import { Col, Row } from 'react-bootstrap';
import * as apiUtility from "../../config/APIUtils";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { Box, Button, Sheet, Tooltip } from '@mui/joy';

function FundedTrainingReport(props) {
    const [expCrsData, setExpCrsData] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    useEffect(() => {
        const fetchReport = async () => {
            setshowSpinner(true);
            try {
                // clone props to avoid mutating original
                const requestBody = JSON.parse(JSON.stringify(props || {}));
                if (requestBody.expDate && requestBody.expDate.startDate && requestBody.expDate.endDate) {
                    const timePart = new Date().toISOString().split('T')[1];
                    requestBody.expDate.startDate = `${requestBody.expDate.startDate}T${timePart}`;
                    requestBody.expDate.endDate = `${requestBody.expDate.endDate}T${timePart}`;
                }
                const apiRequest = { ...apiUtility.apiInputRequest };
                apiRequest.endPoint = "audit-report/fetch-training-report/";
                apiRequest.data = requestBody;
                const res = await apiUtility.updateAsyncAPIDataPUT(apiRequest);
                const courseExpData = res?.data || [];
                setExpCrsData(courseExpData);
            } catch (error) {
                console.error(error);
                setDataForErrorPopup("Unable to fetch report data.");
                setShowErrorPopup(true);
            } finally {
                setshowSpinner(false);
            }
        };

        fetchReport();
    }, [props.homeId, props.expDate]);

    const processedData = (expCrsData || []).map(item => {
        return {
          ...item,
          formattedExpiryDate: item.expiry_date ? new Date(item.expiry_date).toLocaleDateString() : ""
        };
      });
     const headerStyleElement = {
        position: 'sticky',
        top: 0,
        backgroundColor: '#ffffff', 
        borderBottom: '1px solid #016594', 
        zIndex: 1   ,
        
    }
      
      const adminHomeCrsCols = [
        {
            dataField: 'user_id',
            sort: true,
            text: 'User ID',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'firstName',
            sort: true,
            text: 'First Name',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'lastName',
            sort: true,
            text: 'Last Name',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'home_id',
            sort: true,
            text: 'Home ID',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'role_name',
            sort: true,
            text: 'Role Name',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'course_details',
            text: 'Course List',
            headerStyle: headerStyleElement 
        },
        {
            dataField: 'regRequest',
            sort: true,
            text: 'Registration Request',
            headerStyle: headerStyleElement 
        }
    ];

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    const exportInExcel = async () => {
        if (!processedData || processedData.length === 0) {
            setDataForErrorPopup("No data available to export.");
            setShowErrorPopup(true);
            return;
        }

        try {
            var rowsCount = 6;
            const title = [{A: 'CarePassport - Funded Training Report for Home'}];
            let reportView = [{ A:'Name',B:'User ID',C:'Role',D:'Home ID',E:'Date'}];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null)?sessionStorage.getItem('userType').toUpperCase():"User",
                D: '('+props.homeId+')',
                E: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            let reportHeaders = {A:'User ID',B:'First Name',C:'Last Name',D:'Home ID',E:'Role Name',F:'Course ID',G:'Registration Request'};
            reportView.push(reportHeaders);
            processedData.forEach(element => {
                    rowsCount += 1;
                    var tempObj = {
                        A: element.user_id,
                        B: element.firstName,
                        C: element.lastName,
                        D: element.home_id,
                        E: element.role_name,
                        F: element.course_details,
                        G: element.regRequest,
                    };
                    reportView.push(tempObj);
                });
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Home Course Role Report");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "User ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: "A1:G1",
                tbodyRange: `A7:G${finalData.length}`,
                uHeadRange: `A2:G2`,
                uBodyRange: `A3:G3`,
                theadRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:G${headerIndexes[0] + 1}`
                    : null,
                theadRange1:
                  headerIndexes?.length >= 2
                    ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                    : null,
                tFirstColumnRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                    : null,
                tLastColumnRange:
                  headerIndexes?.length >= 1
                    ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                    : null,
          
                tFirstColumnRange1:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                    : null,
                tLastColumnRange1:
                  headerIndexes?.length >= 1
                    ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                    : null,
              };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook)=>{
                workbook.sheets().forEach((sheet)=>{
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(50);
                    sheet.column("D").width(30);
                    sheet.column("E").width(30);
                    sheet.column("F").width(30);
                    sheet.column("G").width(30);
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily:"Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                          horizontalAlignment: "left",
                        });
                      }
                      sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                      });
                      if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                          bold: true,
                        });
                      }
                     
                });
    
                return workbook.outputAsync().then((workbookBlob) => { 
                        const downloadAnchorNode = document.createElement("a");
                        var dateVar = new Date();
                        var fileName = "Carepassport_TrainingSubmissionReportHome-"+dateVar.getDate()+dateVar.getMonth()+dateVar.getFullYear()+"_"+dateVar.getHours()+dateVar.getMinutes()+".xlsx";
                        downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                        downloadAnchorNode.setAttribute("download", fileName);
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();
                });  
            });
        } catch (error) {
             setDataForErrorPopup("Something went wrong while processing excel!");
             setShowErrorPopup(true);
        }
    }

    const NoRowsOverlay = () => {
        return (
            <div className="text-center p-4">
            No records found for the selected date range.
            </div>
        );
        };

    const TABLE_CONTAINER_STYLE = {
        height: '700px',       
        overflowY: 'auto',     
        position: 'relative'   
    };

    

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            {showSpinner && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, py: 2 }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <Tooltip title="Export to Excel" variant="solid">
                    <Button
                        size="sm"
                        variant="outlined"
                        color="primary"
                        disabled={!processedData || processedData.length === 0}
                        onClick={exportInExcel}
                    >                    
                        <RiFileExcel2Line fontSize={"1.5pc"}/>
                    </Button>
                </Tooltip>
            </Box>
            <Sheet variant="outlined" sx={{borderRadius:"md"}} style={TABLE_CONTAINER_STYLE}>
                <BootstrapTable id='organizationStaffSpecificTable' keyField='id' data={processedData} columns={adminHomeCrsCols} striped hover />
            </Sheet>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </Box>
        
    )
}

export default FundedTrainingReport